"use client"

import { ArrowLeft, ExternalLinkIcon, Plus } from "lucide-react"
import { useState } from "react"
import { Button } from "../../../components/ui/button"
import { KitGrid } from "./kit-grid"
import { KitModal } from "./kit-modal"
import type { Category, Kit } from "./categories"

type KitsViewProps = {
  category: Category
  kits: Kit[]
  onBack: () => void
  onAddKit: (kit: Omit<Kit, "id">) => void
  onEditKit: (id: string, kit: Omit<Kit, "id">) => void
  onDeleteKit: (id: string) => void
}

export function KitsView({ category, kits, onBack, onAddKit, onEditKit, onDeleteKit }: KitsViewProps) {
  const [isKitModalOpen, setIsKitModalOpen] = useState(false)
  const [selectedKit, setSelectedKit] = useState<Kit | null>(null)

  return (
    <main className="min-h-screen bg-background">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="mb-8">
          <Button variant="ghost" onClick={onBack} className="mb-4 gap-2 text-muted-foreground hover:text-foreground">
            <ArrowLeft className="h-4 w-4" />
            Voltar para Categorias
          </Button>
          <div className="flex items-center justify-between">
            <div>
              <h1 className="font-sans text-4xl font-bold tracking-tight text-foreground">{category.name}</h1>
              <p className="mt-2 text-muted-foreground">Gerencie os kits desta categoria</p>
            </div>
            <Button
              onClick={() => {
                setSelectedKit(null)
                setIsKitModalOpen(true)
              }}
              size="lg"
              className="gap-2 bg-primary text-primary-foreground hover:bg-primary/90"
            >
              <Plus className="h-5 w-5" />
              Novo Kit
            </Button>
          </div>
        </div>

        <KitGrid
          kits={kits}
          onEdit={(kit) => {
            setSelectedKit(kit)
            setIsKitModalOpen(true)
          }}
          onDelete={onDeleteKit}
        />

        <KitModal
          isOpen={isKitModalOpen}
          onClose={() => {
            setIsKitModalOpen(false)
            setSelectedKit(null)
          }}
          onSave={(kitData) => {
            if (selectedKit) {
              onEditKit(selectedKit.id, { ...kitData, categoryId: category.id })
            } else {
              onAddKit({ ...kitData, categoryId: category.id })
            }
            setIsKitModalOpen(false)
            setSelectedKit(null)
          }}
          initialValue={selectedKit}
        />

        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="font-sans text-4xl font-bold tracking-tight text-foreground">Modelos 3D</h1>
            </div>
            <Button
              id="register-model-category"
              size="lg"
              className="gap-2 bg-primary text-primary-foreground hover:bg-primary/90"
            >
              <ExternalLinkIcon className="h-5 w-5" />
              Registrar Modelo
            </Button>
          </div>
        </div>
      </div>
    </main>
  )
}